module.exports = __webpack_public_path__ + "img/House.89ed4d68.svg";